import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RoutesData from '../../../../routes/factory/routesData';
import getCookie from '../../../../app/helpers/getCookie';

const useNavigatorData = (degreeData) => {
  const { i18n } = useTranslation();
  const [navigatorData, setNavigatorData] = useState([]);
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');

  useEffect(() => {
    const transformDegreeData = (degreeData) => {
      const mappedDegrees = {
        bachelors: [],
        masters: [],
        phds: [],
      };

      degreeData?.items?.forEach((item) => {
        const degreeUrl = item.degreeNameEn?.replace(/\s+/g, '-');
        const degreeInfo = {
          title: item.degreeNameAr,
          route: `/degree-programs/degree/${degreeUrl}/${item.degreeId}`,
        };

        switch (item.degreeType) {
          case 0:
            mappedDegrees.bachelors.push(degreeInfo);
            break;
          case 1:
            mappedDegrees.masters.push(degreeInfo);
            break;
          case 2:
            mappedDegrees.phds.push(degreeInfo);
            break;
          default:
            break;
        }
      });

      return RoutesData.map((section) => {
        if (section.key === 'degrees') {
          return {
            ...section,
            children: section?.children?.map((child) => {
              if (child.key === 'bachelors') {
                return { ...child, children: mappedDegrees.bachelors };
              } else if (child.key === 'masters') {
                return { ...child, children: mappedDegrees.masters };
              } else if (child.key === 'phd') {
                return { ...child, children: mappedDegrees.phds };
              }
              return child;
            }),
          };
        } else if (section.key === 'magazine') {
          return {
            ...section,
            children: section?.children?.map((child) => {
              if (child.key === 'guideline') {
                return {
                  ...child,
                  title: isEnglish
                    ? 'Policies and Guidelines'
                    : 'academics.GUIDELINES',
                };
              }
              return child;
            }),
          };
        }
        return section;
      });
    };

    if (degreeData && degreeData.items) {
      setNavigatorData(transformDegreeData(degreeData));
    } else {
      // fallback when no degree data
      const updatedData = RoutesData.filter(
        (section) => section.title !== 'degree & programs'
      );
      setNavigatorData(updatedData);
    }
  }, [degreeData, i18n.language, isEnglish]);

  return navigatorData;
};

export default useNavigatorData;
